import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { verifyCertificate, certificateImageUrl } from "@/lib/api";
import { ShieldCheck, ShieldX, Loader2, Download } from "lucide-react";
import WishireLogo from "@/components/wishire/WishireLogo";

/* Public certificate verification — the QR on every certificate lands here. */
export default function VerifyCertificate() {
  const { id } = useParams();
  const [d, setD] = useState(null);
  useEffect(() => { verifyCertificate(id).then(({ data }) => setD(data)).catch(() => setD({ valid: false })); }, [id]);
  const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" }) : "");
  return (
    <div className="min-h-screen bg-[#FDFBF7] text-stone-900">
      <div className="container-x py-6"><Link to="/"><WishireLogo size="md" /></Link></div>
      <div className="container-x pb-16 max-w-3xl" data-testid="verify-page">
        {!d ? <p className="text-stone-500 inline-flex items-center gap-2"><Loader2 size={16} className="animate-spin" /> Checking certificate…</p> : d.valid ? (
          <>
            <div className="rounded-3xl border-2 border-emerald-300 bg-emerald-50 p-6 flex items-start gap-4">
              <span className="p-3 rounded-2xl bg-emerald-600 text-white shrink-0"><ShieldCheck size={24} /></span>
              <div>
                <p className="overline text-emerald-700">Valid certificate · {d.cert_id}</p>
                <h1 className="font-display text-3xl mt-1">{d.student_name}</h1>
                <p className="text-stone-700 mt-1">completed <b>{d.course_title}</b>{d.provider ? ` (${d.provider})` : ""}{d.college_name ? ` via ${d.college_name}` : ""}{d.hours ? ` · ${d.hours} hours` : ""}</p>
                <p className="text-sm text-stone-500 mt-1">Issued {fmt(d.issued_at)} on Wishire.</p>
              </div>
            </div>
            <img src={certificateImageUrl(d.cert_id)} alt="Certificate" className="mt-6 w-full rounded-2xl border border-stone-200 shadow-sm" />
            <a href={certificateImageUrl(d.cert_id)} target="_blank" rel="noreferrer" className="mt-4 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-stone-900 text-stone-50 text-sm font-medium hover:bg-[#C2410C]"><Download size={14} /> Open image</a>
          </>
        ) : (
          <div className="rounded-3xl border-2 border-red-200 bg-red-50 p-6 flex items-start gap-4">
            <span className="p-3 rounded-2xl bg-red-600 text-white shrink-0"><ShieldX size={24} /></span>
            <div><p className="overline text-red-700">Not found</p><h1 className="font-display text-3xl mt-1">No certificate with ID {id}</h1><p className="text-stone-700 mt-1">Check the ID on the certificate, or ask the student to open their course on Wishire and share the verify link again.</p></div>
          </div>
        )}
      </div>
    </div>
  );
}
